import { FEATURE_FLAG_NAMES } from "./feature-flag-name";
import type { FlagName } from "./feature-flag-overrides";

// Off when Flipper doesn't know them, even against a local backend: the API
// treats an unknown flag as off, and these switch a product away from its
// default rather than turning a feature on.
const OFF_UNLESS_SET = new Set<FlagName>([
  FEATURE_FLAG_NAMES.profitability_documents_only,
]);

/** A flag's value when Flipper doesn't return it: on against a local backend. */
export const flagDefault = (name: FlagName, appEnv: string) =>
  appEnv === "development" && !OFF_UNLESS_SET.has(name);
